import _extends from 'babel-runtime/helpers/extends';

import NodeName from './NodeName.vue';

export default {
  props: {
    border: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      required: true
    },
    parent: {
      type: Object,
      required: true
    },
    parentId: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    direction: {
      type: String
    },
    level: {
      type: Number,
      required: true
    },
    nodeStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    nameMaxLen: {
      type: Number,
      default: 20
    },
    currentNode: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    updateLayout: {
      type: Function,
      default: function _default() {}
    },
    updateCurrentNode: {
      type: Function,
      default: function _default() {}
    },
    removeNode: {
      type: Function,
      default: function _default() {}
    },
    editNode: {
      type: Function,
      default: function _default() {}
    },
    appendChild: {
      type: Function,
      default: function _default() {}
    },
    maxLevel: {
      type: Number,
      default: 5
    }
  },

  name: 'mind-node',

  data: function data() {
    return {
      isEn: localStorage.getItem('language') === 'en',
      isFold: false,
      nodeWidth: 0,
      nodeHeight: 0,
      timer: 0,
      removeNodePopover: {
        placement: 'top',
        width: 240,
        visible: false
      },
      appendChildPopover: {
        title: '新增子标签',
        placement: 'top',
        width: 300,
        visible: false
      },
      editNodePopover: {
        title: '编辑标签',
        placement: 'top',
        width: 300,
        visible: false
      },
      actionPopover: {
        placement: 'top',
        width: 104,
        visible: false,
        popperClass: 'mind-node-action-popper'
      },
      formConfig: {},
      formValue: {
        name: '',
        name_en: '',
        is_required: ''
      },
      removeNodeButton: {
        type: 'primary',
        size: 'mini',
        loading: false
      },
      appendChildButton: {
        type: 'primary',
        size: 'mini',
        loading: false
      },
      editNodeButton: {
        type: 'primary',
        size: 'mini',
        loading: false
      }
    };
  },


  computed: {
    childrenClass: function childrenClass() {
      return {
        'is-vertical': this.direction === 'vertical'
      };
    },
    isCurrentNode: function isCurrentNode() {
      return this.currentNode.id === this.data.id;
    },
    editable: function editable() {
      return typeof this.data.editable !== 'undefined' ? this.data.editable : true;
    },
    deletable: function deletable() {
      return typeof this.data.deletable !== 'undefined' ? this.data.deletable : true;
    },
    addible: function addible() {
      if (this.level >= this.maxLevel) return false;
      return typeof this.data.addible !== 'undefined' ? this.data.addible : true;
    },
    hadChildren: function hadChildren() {
      return Array.isArray(this.data.children) && this.data.children.length > 0;
    },
    isLeaf: function isLeaf() {
      if (Array.isArray(this.data.children)) {
        if (this.data.children.length === 0) return true;
        return false;
      }
      return true;
    },
    visibleOfIsRequiredFormItem: function visibleOfIsRequiredFormItem() {
      if (this.data.visibleOfIsRequiredFormItem) {
        var status = '';
        if (this.appendChildPopover.visible) {
          status = 'append';
        }
        if (this.editNodePopover.visible) {
          status = 'edit';
        }
        return this.data.visibleOfIsRequiredFormItem(status, this.data);
      }
      return false;
    },
    formItemList: function formItemList() {
      return {
        name: {
          label: '标签名字（中文）',
          prop: 'name',
          params: {
            autofocus: true
          },
          rules: [{
            required: true,
            message: '请填写标签名字',
            trigger: 'blur'
          }, {
            validator: this.validateTag,
            trigger: 'blur'
          }],
          type: 'component',
          component: NodeName
        },
        name_en: {
          label: '标签名字（英文）',
          prop: 'name_en',
          params: {
            autofocus: false
          },
          rules: [{
            required: true,
            message: '请填写标签名字',
            trigger: 'blur'
          }, {
            validator: this.validateTag,
            trigger: 'blur'
          }],
          type: 'component',
          component: NodeName
        },
        is_required: {
          // 只有一级类目才需要展示是否必填项控件
          visible: this.visibleOfIsRequiredFormItem,
          type: 'radio-group',
          label: '该一级类目是否为必填项',
          prop: 'is_required',
          rules: [{
            required: this.visibleOfIsRequiredFormItem,
            message: '请选择该类目是否为必填项',
            trigger: 'change'
          }],
          params: {
            disabled: false,
            options: [{
              value: 1,
              label: 'YES'
            }, {
              value: 2,
              label: 'NO'
            }]
          }
        }
      };
    },
    actionPopoverDisabled: function actionPopoverDisabled() {
      return !this.addible && !this.editable && !this.deletable || this.level > this.maxLevel;
    }
  },

  watch: {
    'appendChildPopover.visible': function appendChildPopoverVisible(val) {
      if (val === false) {
        this.$refs['append-child-form'].clearValidate();
        this.$refs['append-child-form'].resetFields();
      }
      if (val === true) {
        this.updateCurrentNode(this.data);
        this.hideRemoveNodePopover();
        this.hideEditNodePopover();

        // 编辑节点需要对节点弹窗表单赋值
        this.formValue = {
          name: '',
          name_en: '',
          is_required: ''
        };
      }
    },
    'editNodePopover.visible': function editNodePopoverVisible(val) {
      if (val === false) {
        this.$refs['edit-node-form'].clearValidate();
        this.$refs['edit-node-form'].resetFields();
      }
      if (val === true) {
        this.updateCurrentNode(this.data);
        this.hideRemoveNodePopover();
        this.hideAppendChildPopover();

        // 编辑节点需要对节点弹窗表单赋值
        this.formValue = {
          name: this.data.name,
          name_en: this.data.name_en,
          is_required: this.data.is_required
        };
      }
    },
    'removeNodePopover.visible': function removeNodePopoverVisible(val) {
      if (val === true) {
        this.updateCurrentNode(this.data);
        this.hideEditNodePopover();
        this.hideAppendChildPopover();
      }
    }
  },

  mounted: function mounted() {
    if (this.$refs['mind-node-text']) {
      this.nodeWidth = this.$refs['mind-node-text'].offsetWidth;
      this.nodeHeight = this.$refs['mind-node-text'].offsetHeight;
    }
  },


  methods: {
    toggleChildren: function toggleChildren() {
      this.isFold = !this.isFold;
      this.updateLayout();
    },
    handleNodeClick: function handleNodeClick() {
      this.updateCurrentNode(this.data);
    },
    submitAppendChild: function submitAppendChild() {
      var _this = this;

      this.appendChildButton.loading = true;

      this.$refs['append-child-form'].validate(function (valid) {
        if (!valid) {
          _this.appendChildButton.loading = false;
          return;
        }

        var node = _extends({}, _this.formValue);
        // is_required 不是必选属性
        if (!_this.visibleOfIsRequiredFormItem) {
          delete node.is_required;
        }

        // 新增节点的时候要滚动到指定位置
        _this.appendChild({
          node: _extends({}, node),
          id: _this.data.id
        },
        /**
         * success cb
         * @param {{}} newNode 新生成节点
         */
        function (newNode) {
          _this.appendChildButton.loading = false;
          _this.hideAppendChildPopover();
          _this.hideActionPopover();
          _this.updateCurrentNode(newNode);
        },
        // fail cb
        function () {
          _this.appendChildButton.loading = false;
        });
      });
    },
    hideAppendChildPopover: function hideAppendChildPopover() {
      this.appendChildPopover.visible = false;
    },
    submitRemoveNode: function submitRemoveNode() {
      var _this2 = this;

      this.removeNodeButton.loading = true;

      this.removeNode({
        id: this.data.id,
        parentId: this.parentId
      },
      // success cb
      function () {
        _this2.removeNodeButton.loading = false;
        _this2.hideRemoveNodePopover();
      },
      // fail cb
      function () {
        _this2.removeNodeButton.loading = false;
      });
    },
    hideRemoveNodePopover: function hideRemoveNodePopover() {
      this.removeNodePopover.visible = false;
    },
    submitEditNode: function submitEditNode() {
      var _this3 = this;

      this.editNodeButton.loading = true;

      this.$refs['edit-node-form'].validate(function (valid) {
        if (!valid) {
          _this3.editNodeButton.loading = false;
          return;
        }

        var node = _extends({}, _this3.formValue);
        // is_required 不是必选属性
        if (!_this3.visibleOfIsRequiredFormItem) {
          delete node.is_required;
        }

        // 新增节点的时候要滚动到指定位置
        _this3.editNode({
          node: _extends({}, node),
          id: _this3.data.id
        },
        // success cb
        function () {
          _this3.editNodeButton.loading = false;
          _this3.hideEditNodePopover();
        },
        // fail cb
        function () {
          _this3.editNodeButton.loading = false;
        });
      });
    },
    hideEditNodePopover: function hideEditNodePopover() {
      this.editNodePopover.visible = false;
    },
    hideActionPopover: function hideActionPopover() {
      this.actionPopover.visible = false;
    },


    // TODO
    validateTag: function validateTag(rule, value, callback) {
      if (/^\s+$/.test(value)) {
        callback(new Error('标签名称不能只存在空格'));
        return;
      }

      value = value.trim();

      if (value.length > this.nameMaxLen) {
        callback(new Error('\u6807\u7B7E\u540D\u79F0\u957F\u5EA6\u4E0D\u80FD\u8D85\u8FC7' + this.nameMaxLen));
        return;
      }
      callback();
    }
  }
};